// extracted by mini-css-extract-plugin
export default {"body":"style_body__SpJ4K","input":"style_input__zHzsj","timer":"style_timer__dJDVT","error":"style_error__terY1"};